module.exports = __webpack_public_path__ + "static/img/Inform.483be9d0.webp";